import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MUITable from "../../../../Common/MUITable";
import { TableLoader } from "../../../../Common/ShimmerLoader";
import useGrievanceReportStore from "../../GrievanceDetailedReport/store/grievanceReportStore";
import isGHMC from "../../../../Common/helper/helpar";
import { MSWManagementVehiclesFilter } from "./MSWManagementVehiclesFilter";
import { MSWManagementVehiclesExport } from "./MSWManagementVehiclesExport";
export const MSWManagementVehiclesOnRoad = () => {
    const {
        grievanceReportData,
        loading,
        grievanceItemsDropedownList,
        fetchgrievanceDetailedReport,
        grievanceItemList,
        setSelectedComplaintNo,
        selectComplaintNo,
        setStatus,
        selectedStatus,
        setSelectedIEName,
        selectIEName } = useGrievanceReportStore();
    const isProd = isGHMC()
    const [modalShow, setModalShow] = useState(false);
    const [selectedGrievanceData, setSelectedGrievanceData] = useState(null);
    console.log(grievanceItemsDropedownList)

    useEffect(() => {
        // Initial fetch without filters
        fetchgrievanceDetailedReport();
    }, []);

    // Function to fetch data with filters when clicking search
    const handleSearch = () => {
        fetchgrievanceDetailedReport({
            complaintNo: selectComplaintNo,
            status: selectedStatus,
            ieEngineerId: selectIEName

        });
    };

    const grievanceReportHeaderColumns = [
        { label: "Date", field: "complaintNo" },
        { label: <>Total Number Of Vehicles<br /> Planned For Deployment (a)</>, field: "kpiCategoryName" },

        {
            // name: <>Cleared GVPs<br/>Points</> ,
            label: <>Total Number Of<br />  Vehicles Deployed  (b)</>,
            field: "ieEngineerName"
        },

        { label: "Performance Achieved", field: "description" },
        { label: "Remarks", field: "description" },

    ];

    return (

        <div>
            <div className="card mt-3">
                <div className="">
                    <div className="top-header">
                        <span>MSW Management Vehicles On The Road - Secondary Collection</span>
                    </div>
                    <MSWManagementVehiclesFilter />
                    {/* {isFetchingZoneWiseTrips && <TableLoader height={460} />} */}

                    <MUITable loading={loading}
                            needSRNumber
                            columns={grievanceReportHeaderColumns}
                            // rows={grievanceReportData}
                            tableHeight={500}
                        />
                </div>
            </div>
        </div>
    );
};
